import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// 📄 Obtener anticipos de un documento
export const getExpenseAdvances = async (documentId) => {
  const res = await axios.get(
    `${API_URL}/api/expense-advances/document/${documentId}`,
    { headers: authHeaders() }
  );
  return res.data;
};

// ➕ Crear anticipo
export const createExpenseAdvance = async (data) => {
  const res = await axios.post(`${API_URL}/api/expense-advances`, data, {
    headers: authHeaders(),
  });
  return res.data;
};

// ✏️ Actualizar anticipo
export const updateExpenseAdvance = async (id, data) => {
  const res = await axios.put(`${API_URL}/api/expense-advances/${id}`, data, {
    headers: authHeaders(),
  });
  return res.data;
};

// 🗑 Eliminar anticipo
export const deleteExpenseAdvance = async (id) => {
  await axios.delete(`${API_URL}/api/expense-advances/${id}`, {
    headers: authHeaders(),
  });
};
